import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { NxButtonModule } from "@aposin/ng-aquila/button";
import { NxCopytextModule } from "@aposin/ng-aquila/copytext";
import { NxHeadlineModule } from "@aposin/ng-aquila/headline";
import { NX_MODAL_DATA, NxModalRef } from "@aposin/ng-aquila/modal";
import { NxModalModule } from "@aposin/ng-aquila/modal";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-message-prompt-modal",
  standalone: true,
  imports: [
    CommonModule,
    NxButtonModule,
    NxCopytextModule,
    NxHeadlineModule,
    NxModalModule,
    TranslateModule,
  ],
  templateUrl: "./message-prompt-modal.component.html",
  styleUrl: "./message-prompt-modal.component.scss",
})
export class MessagePromptModalComponent {
  protected message: any;

  constructor(
    @Inject(NX_MODAL_DATA) data: any,
    private readonly dialogRef: NxModalRef<any>,
  ) {
    this.message = data.message;
  }

  protected onclickOK() {
    this.dialogRef.close("OK");
  }
}
